<template>
  <v-tooltip v-bind="tooltipAttributes">
    <template #activator="{ attrs, on }">
      <span v-on="on">
        <slot name="slot-button">
          <v-btn
            v-bind="{ ...attrs, ...$attrs }"
            :class="buttonClass"
            v-on="{ ...on, ...$listeners }"
          >
            <span v-if="buttonTextLeft" class="mr-2">{{ buttonTextLeft }}</span>
            <slot>
              <v-icon v-if="iconName" icon v-bind="iconProps">{{
                iconName
              }}</v-icon>
            </slot>
            <span v-if="buttonTextRight" class="ml-2">{{
              buttonTextRight
            }}</span>
            {{ buttonText }}
            <slot name="badge"></slot>
          </v-btn>
        </slot>
      </span>
    </template>
    <slot name="tooltip-content">
      <span>{{ tooltipText }}</span>
    </slot>
  </v-tooltip>
</template>

<script>
export default {
  name: "ButtonTooltip",
  props: {
    tooltipText: {
      type: String,
      default: "",
    },
    tooltipProps: {
      type: Object,
      default: () => {},
    },
    iconName: {
      type: String,
      default: "",
    },
    iconProps: {
      type: Object,
      default: () => {},
    },
    buttonClass: {
      type: String,
      default: "",
    },
    buttonTextLeft: {
      type: String,
      default: "",
    },
    buttonTextRight: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
  },
  computed: {
    tooltipAttributes() {
      return {
        bottom: true,
        ...this.tooltipProps,
      }
    },
  },
}
</script>
